import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetScroll = () => {
  // window scroll
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // inner scroll containers (layout wrappers with overflow-y: auto)
  document.querySelectorAll("div, main, section").forEach((el) => {
    if (el.scrollTop > 0) el.scrollTop = 0;
  });
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    resetScroll();
    // run again after images / socket data change the page height
    const t1 = setTimeout(resetScroll, 100);
    const t2 = setTimeout(resetScroll, 400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname]);

  return null;
}